import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=777c3cde&scoped=true"
import script from "./consultation.vue?vue&type=script&lang=js"
export * from "./consultation.vue?vue&type=script&lang=js"
import style0 from "./consultation.vue?vue&type=style&index=0&id=777c3cde&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777c3cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777c3cde')) {
      api.createRecord('777c3cde', component.options)
    } else {
      api.reload('777c3cde', component.options)
    }
    module.hot.accept("./consultation.vue?vue&type=template&id=777c3cde&scoped=true", function () {
      api.rerender('777c3cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workShop/consultation.vue"
export default component.exports